'use strict';

import { CoreRepository } from '../CoreRepository';
import { UserAlert } from '../../Entities/User/UserAlert';
import { UserAlertCollection } from '../../Collections/User/UserAlertCollection';

export class UserAlertRepository extends CoreRepository {
  public getUserAlerts(userId: number) {
    return this.webAPI.getUserAlerts(userId).then((response) => {
      const collection = new UserAlertCollection();

      response.data.forEach((collectionItemData) => {
        const collectionItem = new UserAlert();
        collectionItem.hydrate(collectionItemData);

        collection.addItem(collectionItem);
      });

      collection.setOffset(response.offset);
      collection.setLimit(response.limit);
      collection.setTotal(response.total);

      return collection;
    });
  }

  public addUserAlert(userId: number, payload: object = {}) {
    return this.webAPI.addUserAlert(userId, payload).then((response) => {
      const item = new UserAlert();
      item.hydrate(response);

      return item;
    });
  }

  public updateUserAlert(userId: number, alertId: number, payload: any[]) {
    return this.webAPI.updateUserAlert(userId, alertId, payload).then((response) => {
      return response;
    });
  }
}
